import { lazy } from "react";

export const UpdateDoctorAsync = lazy(() => import("./UpdateDoctor"));
